var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-button"},[_c('button',{class:{ inverted: _vm.inverted, disabled: _vm.disabled },style:(_vm.cssVars),on:{"click":function($event){return _vm.onClick()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }